export default "/assets/images/winking-face.png?b9491ead20a13da524d656c82ac8ea5b";